module.exports = __webpack_public_path__ + "img/logo_fr.50bbfe5e.png";